import React from 'react';
import UIProvider from './src/context/ui-context/UIProvider';

export const wrapRootElement = ({ element }) => {
  return <UIProvider>{element}</UIProvider>;
};
